var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "render-post hide-scrollbar render-post-google",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c("div", { staticClass: "post-content" }, [
        _c("div", { staticClass: "post-header" }, [
          _c(
            "div",
            { staticClass: "img-pages" },
            [
              _vm._l(
                _vm.pages.slice(0, _vm.pages.length == 4 ? 4 : 3),
                function (page, index) {
                  return [
                    _c(
                      "Tooltip",
                      {
                        key: index,
                        attrs: {
                          active: page.iconEdited,
                          text: "Voir les modifications apportées",
                          position: "right",
                          classCustom: `page ${
                            page.iconEdited ? "iconEdited" : ""
                          }`,
                        },
                        on: {
                          click: () => {
                            page.iconEdited
                              ? _vm.$emit("clickPage", page.id)
                              : _vm.openGooglePage(page)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              page && page.avatar
                                ? page.avatar
                                : "img/avatar.jpg",
                            alt: "",
                          },
                        }),
                      ]
                    ),
                  ]
                }
              ),
              _vm.pages.length > 4
                ? _c("div", { staticClass: "page count" }, [
                    _c("p", [_vm._v("+" + _vm._s(_vm.pages.length - 3))]),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _vm.pages.length == 1
            ? _c("div", { staticClass: "info" }, [
                _c(
                  "p",
                  {
                    staticClass: "name",
                    on: {
                      click: function ($event) {
                        return _vm.openGooglePage(_vm.pages[0])
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.pages[0].name))]
                ),
                _c("p", { staticClass: "google" }, [_vm._v("sur Google")]),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "card-post" },
          [
            _vm.medias.length &&
            _vm.medias.find(
              (m) => m.info.type2 == "image" && m.info.type !== "image/gif"
            )
              ? _vm._l(
                  _vm.medias
                    .filter(
                      (m) =>
                        m.info.type2 == "image" && m.info.type !== "image/gif"
                    )
                    .slice(0, 1),
                  function (media) {
                    return _c(
                      "div",
                      { key: media.id, staticClass: "post-medias media" },
                      [
                        _c("div", { staticClass: "media" }, [
                          _c("img", { attrs: { src: media.url, alt: "" } }),
                        ]),
                      ]
                    )
                  }
                )
              : _vm.snippet.link
              ? _c(
                  "div",
                  { staticClass: "snippet" },
                  [_c("SnippetNetwork", { attrs: { link: _vm.snippet.link } })],
                  1
                )
              : _c("div", { staticClass: "post-empty" }),
            _c("div", { staticClass: "content-card-post" }, [
              _vm.text
                ? _c("div", { staticClass: "post-text" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.textTranslateMentionAndHastag),
                      },
                    }),
                  ])
                : _vm._e(),
              _vm.snippet.link
                ? _c("p", { staticClass: "redirection" }, [
                    _c("a", [
                      _vm._v(
                        "En savoir plus  (" +
                          _vm._s(_vm.getHostname(_vm.snippet.link)) +
                          ")"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("p", { staticClass: "date" }, [
                _vm._v(
                  _vm._s(_vm.datePost ? _vm.formatDatePost : "A l'instant")
                ),
              ]),
            ]),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }